import React, { Component } from "react";
import { Form, Image } from "react-bootstrap";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import IconClose from "../../assets/cross-icon.svg";
import PragatiCalendarFilter from "../calendarFilter/PragatiCalender";
import CalendarFilter from "../calendarFilter/CalendarFilter";
import CalendarFilterAgenda from "../calendarFilter/CalendarFilterAgenda";
import { isFunction } from "lodash";
import { SearchComponent } from "../../component/SearchComponent";
import { isValidArray, SORT_BY } from "../../helper";
import { OTHER_CALENDER } from "../../constant";
import AgendaList from "../PRAGATI/PragatiListSingle";
const issueListParams = {
  limit: 10,
  offset: 0,
  sortBy: "CREATED_DATE",
  sortOrder: "DESC",
  displayDateTitle: "- Created Date -"
};

export class IssueSearchSorting extends Component {
  state = {
    search: "",
    sortStatus: false,
    sort: false,
    checkStatus: ""
  };

  getProperty(prop) {
    return this.hasOwnProperty(prop);
  }

  handleCalendarFilterData = (filteredMeetings, flag, filterTitle, value) => {
    //console.log("handleCalendarFilterData", filteredMeetings, value)
    const { onCalenderChange } = this.props;
    onCalenderChange(filteredMeetings, flag, filterTitle, value);
  };

  // value must be an object like { search: 'text' }
  onChange = value => {
    let { params } = this.props;
    let newParam = { ...params, ...value, offset: 0 };
    const fun = this.getProperty.bind(newParam);
    // extract params
    // now set params according to object key
    if (fun("search") || fun("projectGroupBy")) {
      newParam = { ...newParam, sortBy: null, sortOrder: null };
    }

    // if (fun("search")) {
    //   newParam["projectGroupBy"] = null;
    // }

    this.callApi({ ...newParam });
  };

  onHandleSort = () => {
    this.setState(prevState => ({ sortStatus: !prevState.sortStatus }));
  };

  onChangeSort = value => {
    const { params } = this.props;
    this.setState(
      prevState => ({ sortStatus: !prevState.sortStatus }),
      () => {
        this.callApi({
          ...params,
          checkStatus: value.name,
          projectGroupBy: null,
          sortBy: value.sortBy,
          sortOrder: value.sortOrder,
          offset: 0
        });
      }
    );
  };

  callApi = params => {
    const { callApiOnSuccess } = this.props;
    isFunction(callApiOnSuccess) && callApiOnSuccess({ ...params });
  };

  render() {
    const { sortStatus } = this.state;
    const {
      params = {},
      sortBy = [],
      pragaticss,
      PRAGATI_LIST,
      calenderDisplaytext,
      searchValue,
      isAgendaList
    } = this.props;
    const { checkStatus, search, dates } = params;

    return (
      <React.Fragment>
        <div
          className={
            pragaticss
              ? "issue-list-exposed-filters-pragati"
              : "issue-list-exposed-filters"
          }
        >
          <div className="issue-list-filter-right">
            {pragaticss ? (
              <>
                <PragatiCalendarFilter
                  onChange={this.onChange}
                  calenderOptions={
                    PRAGATI_LIST == undefined ? OTHER_CALENDER : PRAGATI_LIST
                  }
                  displayDateTitle={
                    pragaticss
                      ? dates || "- Meeting Date -"
                      : dates || "- Created Date -"
                  }
                  onCalenderChange={this.handleCalendarFilterData}
                  calenderDisplaytext={calenderDisplaytext}
                  searchValue={searchValue}
                />
              </>
            ) : (
              <>
                {isAgendaList ? (
                  <CalendarFilterAgenda
                    onChange={this.onChange}
                    calenderOptions={
                      PRAGATI_LIST == undefined ? OTHER_CALENDER : PRAGATI_LIST
                    }
                    displayDateTitle={dates ? dates : "- Meeting Date -"}
                    onCalenderChange={this.handleCalendarFilterData}
                    calenderDisplaytext={calenderDisplaytext}
                    searchValue={searchValue}
                    isAgendaList={isAgendaList}
                  />
                ) : (
                  <CalendarFilter
                    onChange={this.onChange}
                    calenderOptions={
                      PRAGATI_LIST == undefined ? OTHER_CALENDER : PRAGATI_LIST
                    }
                    displayDateTitle={
                      pragaticss
                        ? dates || "- Meeting Date -"
                        : dates || "- Created Date -"
                    }
                    onCalenderChange={this.handleCalendarFilterData}
                    calenderDisplaytext={calenderDisplaytext}
                    searchValue={searchValue}
                    isAgendaList={isAgendaList}
                  />
                )}
              </>
            )}

            <Form>
              <Form.Group
                className="search-box search-container-component"
                style={{
                  maxHeight: "inherit",
                  marginRight:
                    window.location.pathname == "/pragati-list" ? "12px" : ""
                }}
              >
                <SearchComponent
                  keyName="searchText"
                  value={search}
                  onChange={value => {
                    this.onChange({ search: value.searchedText });
                  }}
                  delay={1000}
                />
              </Form.Group>
            </Form>
            <div
              className={`agensort dropdown field-sort ${
                sortStatus ? "visible" : ""
              }`}
              onClick={this.onHandleSort}
              style={{
                display: pragaticss ? "none" : null,
                marginLeft:
                  window.location.pathname == "/agenda-list" ? "15px" : ""
              }}
            >
              <div
                className={`dropdown-overlay ${sortStatus ? "visible" : ""}`}
              />
              <div className="dropdown-selected-value">Sort</div>
              <div className="dropdown-option-list hidden-mobile">
                <div className="dropdown-option-list-heading">
                  <div className="list-sort">Sort By</div>
                  <Image src={IconClose} alt="Close Icon" />
                </div>
                {isValidArray(sortBy)
                  ? sortBy.map(value => {
                      return (
                        <div
                          onClick={e => {
                            e.stopPropagation();
                            this.onChangeSort(value);
                          }}
                          className={checkStatus === "high" ? "active" : ""}
                        >
                          {value.name}
                        </div>
                      );
                    })
                  : null}
              </div>
            </div>
          </div>
        </div>

        {/*For mobile*/}
        <div className="sort-section hidden-desktop">
          <div className={`sort-container ${sortStatus ? "visible" : ""}`}>
            <div className={`sort-popup ${sortStatus ? "visible" : ""}`}>
              <div className="popup-title">
                Sort By
                <button type="button" className="close">
                  <span aria-hidden="true" onClick={this.onHandleSort}>
                    ×
                  </span>
                </button>
              </div>
              <div className="popup-body">
                <ul>
                  <li>
                    <input
                      type="radio"
                      name="issue"
                      value="high"
                      onClick={e => {
                        e.stopPropagation();
                        this.onChangeSort("high");
                      }}
                    />{" "}
                    <b>High</b>&nbsp;Budget
                  </li>
                  <li>
                    <input
                      type="radio"
                      name="issue"
                      value="low"
                      onClick={e => {
                        e.stopPropagation();
                        this.onChangeSort("low");
                      }}
                    />{" "}
                    <b>Low</b>&nbsp;Budget
                  </li>
                  <li>
                    <input
                      type="radio"
                      name="issue"
                      value="latest"
                      onClick={e => {
                        e.stopPropagation();
                        this.onChangeSort("latest");
                      }}
                    />{" "}
                    <b>Latest</b>&nbsp;Created
                  </li>
                  <li>
                    <input
                      type="radio"
                      name="issue"
                      value="old"
                      onClick={e => {
                        e.stopPropagation();
                        this.onChangeSort("old");
                      }}
                    />{" "}
                    <b>Old</b>&nbsp;Created
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        {/*For mobile*/}
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {};
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({}, dispatch);
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(IssueSearchSorting);
